import * as AudioFormat from "../interfaces/IAudioFormat";
import { WavFormat } from "./WavFormat";

export function CreateAndInitializeAudioFormat(formatProps: AudioFormat.IFormatProperties): AudioFormat.IAudioFormat {
    switch (formatProps.format) {
        case AudioFormat.SupportedFormats.wav:
            const format: AudioFormat.IAudioFormat = new WavFormat();
            format.InitializeEncoder(formatProps);
            return format;
        default:
            throw new Error("Unknown format: " + formatProps.format);
    }
}
